import { Link } from 'react-router-dom';

import { ROUTE } from '../../../App';
import cn from '../../../lib/classNames';
import SocialMedias from '../SocialMedia/SocialMedia';

import styles from './Footer.module.scss';

type FooterType = {
	classPageContent?: string;
};

export default function Footer(props: FooterType) {
	const { classPageContent } = props;

	return (
		<footer className={styles.footer}>
			<div className={cn(styles.content, classPageContent)}>
				<SocialMedias />
				<div className={styles.wrap}>
					<div className={styles.copy}>© Safe-esteem, Inc. All rights reserved</div>
					<div className={styles.links}>
						<a className={styles.link} href="https://www.safe-esteem.com/privacy">
							Privacy Policy
						</a>
						<a className={styles.link} href="https://www.safe-esteem.com/terms-of-use">
							Terms of Use
						</a>
						<a className={styles.link} href="https://www.safe-esteem.com/terms-of-use">
							End User License Agreement
						</a>
						<a className={styles.link} href="https://www.safe-esteem.com/about">
							About Safe-esteem
						</a>
						<Link to={ROUTE.welcome}>
							<span className={styles.link}>Safe-xplore AI</span>
						</Link>
					</div>
				</div>
			</div>
		</footer>
	);
}
